import script from "./FooterHero.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterHero.vue?vue&type=script&setup=true&lang=js"

import "./FooterHero.vue?vue&type=style&index=0&id=4733e305&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4733e305"]])

export default __exports__